/* import __COLOCATED_TEMPLATE__ from './discover.hbs.js'; */
var _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { COMMON as architecturesCommon, UNCOMMON as architecturesUncommon } from 'vagrant/utils/architectures';
const asFilters = val => {
  if (!val) return;

  // Special case for single values
  if (!['"', '['].includes(val[0] ?? '')) return [{
    value: val,
    text: val
  }];

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  return JSON.parse(val).map(s => ({
    value: s,
    text: s
  }));
};
const valuesFromFilter = (config, name) => {
  const filter = config.filters?.[name];
  if (!filter) return;
  if (filter instanceof Array) {
    if (filter.length === 1) return filter[0]?.value;
    return JSON.stringify(filter.map(f => f.value));
  }
  return filter.value;
};
const DEFAULT_SORT = 'downloads desc';
const SORT_TO_TRANSLATION_KEY = {
  'relevance asc': 'discover.search.sort.relevance',
  'downloads desc': 'discover.search.sort.downloads',
  'created_at desc': 'discover.search.sort.created',
  'updated_at desc': 'discover.search.sort.updated'
};
const sortTextFor = (intl, sortVal = '') => {
  const key = SORT_TO_TRANSLATION_KEY[sortVal];
  return key ? intl.t(key) : 'unknown sort val';
};
let _class = (_class2 = class _class2 extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "api", _descriptor, this);
    _initializerDefineProperty(this, "vagrantContext", _descriptor2, this);
    _initializerDefineProperty(this, "router", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _defineProperty(this, "architecturesCommon", architecturesCommon);
    _defineProperty(this, "architecturesUncommon", architecturesUncommon);
    // TODO: This will come from the API in some fashion
    _defineProperty(this, "providersCommon", ['docker', 'qemu', 'virtualbox', 'vmware', 'vsphere']);
    _defineProperty(this, "providersUncommon", ['aws', 'cloudstack', 'digitalocean', 'google', 'hyperv', 'libvirt', 'lxc', 'openstack', 'parallels', 'rackspace', 'softlayer', 'veertu', 'vmware_desktop', 'vmware_fusion', 'vmware_ovf', 'vmware_workstation', 'xenserver']);
  }
  get filterConfig() {
    return {
      search: {
        value: this.args.filters?.query
      },
      filters: {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        providers: asFilters(this.args.filters?.providers),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        architectures: asFilters(this.args.filters?.architectures)
      },
      sort: {
        value: this.args.filters?.sort ?? DEFAULT_SORT,
        text: sortTextFor(this.intl, this.args.filters?.sort ?? DEFAULT_SORT)
      }
    };
  }
  get count() {
    return this.args.boxes?.length ?? 0;
  }
  filter(config) {
    const sort = config.sort?.value;
    const qps = {
      query: config.search?.value,
      providers: valuesFromFilter(config, 'providers'),
      architectures: valuesFromFilter(config, 'architectures'),
      sort: sort !== DEFAULT_SORT ? sort : undefined,
      // Reset pagination
      next: undefined,
      prev: undefined
    };
    this.router.transitionTo('discover', {
      queryParams: qps
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "api", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "vagrantContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "filter", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "filter"), _class2.prototype), _class2);
export { _class as default };